import { useDeleteAprendizPrograma } from "@/hooks/aprendicesProgramas/useAprendicesProgramas";
import type { AprendizPrograma } from "@/interfaces/aprendizPrograma.interface";
import { AccionesGenericas } from "./AccionesGenericas";
import { Button } from "@/components/ui/button";
import { ChevronRight } from "lucide-react";
import { useNavigate } from "react-router";

type AccionesAprendizProgramaCellProps = {
  aprendizPrograma: AprendizPrograma;
};

export default function AccionesAprendizProgramaCell({
  aprendizPrograma,
}: AccionesAprendizProgramaCellProps) {
  const { mutate } = useDeleteAprendizPrograma();
  const navigate = useNavigate();

  const handleVerActividades = () => {
    navigate(
      `/admin/aprendices-programas/${aprendizPrograma.idAprendiz}/programa/${aprendizPrograma.idPrograma}/actividades`
    );
  };

  return (
    <AccionesGenericas
      data={aprendizPrograma}
      id={aprendizPrograma.id}
      label="Aprendiz"
      onDelete={(id) => mutate(id)}
      extraActions={() => (
        <Button
          size="icon"
          variant="icon"
          onClick={handleVerActividades}
          title="Ver actividades"
        >
          <ChevronRight className="h-4 w-4 text-emerald-600" />
        </Button>
      )}
    />
  );
}
